import Link from 'next/link';
import drsUrl from '@drs/url';

interface IRoadshowLinkProps {
  title: string,
  email: string,
  entryCode: string,
  className?: string,
}

const RoadshowLink = ({
  title,
  entryCode,
  email,
  className = '',
}: IRoadshowLinkProps) => {
  const url = `/login/investor/e/${ entryCode }?email=${ email }&entry_code=${ entryCode }&source=cfr`;

  return <Link href={ drsUrl.getUrl(url) } target="_blank" className={ className }>{ title }</Link>;
};

export default RoadshowLink;
